

















































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwCountryIcon } from '@libs-uuif/shared/sw-country-icon';
import { SwSelect, SelectOption } from '@libs-uuif/shared/sw-select';
import Component from 'vue-class-component';
import { Watch, Prop } from 'vue-property-decorator';
import { countryCodes } from '../country-selector/countryCodes';

@Component({
  components: {
    SwCountryIcon,
    SwSelect,
  },
})
export default class SwCountryChoose extends SwExtendedVue {
  // by default US is selected
  selectValue: string = '';
  options: SelectOption[] = countryCodes;
  returningValue : any = '';
  @Prop({ required: false })
  countryList: any;
  dummyValue: any;
  filteredData : SelectOption[] = [];
  defaultdata : SelectOption = { id:'default', label:'Choose Country' , value:'default' };
  @Watch('selectValue')
  onValueChanges(value : any) {
    this.selectValue = value;
    if (this.selectValue !== '') {
      countryCodes.filter((each : any) => {
        if (each.id === this.selectValue) {
          this.returningValue =  each.value;
        }
      });
      this.$emit('input', this.returningValue);
    } else {
      this.$emit('input', this.selectValue);
    }
  }

  created() {
    this.$emit('input', this.returningValue);
    // adding country which are not in UUIF
    this.countryList.forEach((ele : any) => {
      let flag = 0;
      countryCodes.forEach((element : any) => {
        if (ele.countryCode === element.value) {
          flag = 1;
          element.label = ele.name;
        }
      });
      if (flag === 0) {
        const inner : any = {};
        inner['id'] = ele.countryCode;
        inner['label'] = ele.name;
        inner['value'] = ele.countryCode;
        countryCodes.push(inner);
        console.warn(inner);
      }
    });
    this.filteredData = countryCodes.filter((ele : any) => {
      const list = this.countryList.filter((element:any) => {
        return element.countryCode === ele.value;
      });
      return list.length > 0 ? true : false;
    });
    this.filteredData.sort((a:SelectOption, b:SelectOption) => {
      if (a.label < b.label) {
        return -1;
      }
      if (a.label > b.label) {
        return 1;
      }
      return 0;
    });
  }
}
